import { useReducer } from 'react';

import * as ACTIONS from './actions';
import initialState from './initialstate';
import reducer from './reducer';

const useDxWorkSection = service => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addDx = (
    encounterId,
    cmsCodeId,
    supportingText,
    reasonOptions
  ) => {
    dispatch(ACTIONS.addDxRequest());

    return service.addDx(encounterId, cmsCodeId, supportingText, reasonOptions)
      .then(listItems => {
        dispatch(ACTIONS.addDxSuccess(listItems || []));
        return Promise.resolve(null);
      })
      .catch(e => dispatch(ACTIONS.addDxFailure(e.toString())));
  };

  const hydrate = (listItems, auditReasons) =>
    dispatch(ACTIONS.hydrate(listItems, auditReasons));

  const approveDx = (encounterId, encounterCmsCodeIds, reasonOptions) => {
    dispatch(ACTIONS.approveDxRequest());

    return service.approveDx(encounterId, encounterCmsCodeIds, reasonOptions)
      .then(listItems => {
        dispatch(ACTIONS.approveDxSuccess(listItems));
        return Promise.resolve(null);
      })
      .catch(e => dispatch(ACTIONS.approveDxFailure(e.toString())));
  };

  const unapproveDx = (encounterId, encounterCmsCodeId) => {
    dispatch(ACTIONS.unapproveDxRequest());

    return service.unapproveDx(encounterId, encounterCmsCodeId)
      .then(listItems => {
        dispatch(ACTIONS.unapproveDxSuccess(listItems));
        return Promise.resolve(null);
      })
      .catch(e => dispatch(ACTIONS.unapproveDxFailure(e.toString())));
  };

  const removeDx = (encounterId, encounterCmsCodeIds, reasonOptions) => {
    dispatch(ACTIONS.removeDxRequest());

    return service.removeDx(encounterId, encounterCmsCodeIds, reasonOptions)
      .then(listItems => {
        dispatch(ACTIONS.removeDxSuccess(listItems));
        return Promise.resolve(null);
      })
      .catch(e => dispatch(ACTIONS.removeDxFailure(e.toString())));
  };

  const unremoveDx = (encounterId, encounterCmsCodeId) => {
    dispatch(ACTIONS.unremoveDxRequest());

    return service.unremoveDx(encounterId, encounterCmsCodeId)
      .then(listItems => {
        dispatch(ACTIONS.unremoveDxSuccess(listItems));
        return Promise.resolve(null);
      })
      .catch(e => dispatch(ACTIONS.unremoveDxFailure(e.toString())));
  };

  // const toggleEncounterAuditReason = id => {
  //   dispatch(ACTIONS.toggleEncounterAuditReason(id));
  // }

  const beginMultiselect = item => dispatch(ACTIONS.beginMultiselect(item));
  const endMultiselect = () => dispatch(ACTIONS.endMultiselect());
  const selectItemMultiselect = item =>
    dispatch(ACTIONS.selectItemMultiselect(item));
  const deselectItemMultiselect = item =>
    dispatch(ACTIONS.deselectItemMultiselect(item));

  const boundActions = {
    addDx,
    approveDx,
    unapproveDx,
    removeDx,
    unremoveDx,
    hydrate,
    // toggleEncounterAuditReason,
    beginMultiselect,
    endMultiselect,
    selectItemMultiselect,
    deselectItemMultiselect
  };

  return [state, boundActions];
};

export default useDxWorkSection;
